module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "HomePage"
    }
  }, [(!_vm.isUserLoggedIn) ? _c('Navigation', {
    attrs: {
      "hideLogo": "true",
      "page": "mainPage",
      "backgroundColor": "rgba(0,0,0, 0.4)",
      "showUserNav": true
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isUserLoggedIn) ? _c('Navigation', {
    attrs: {
      "hideLogo": "true",
      "page": "mainPage",
      "showUserNav": true
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "view hm-blue-slight",
    class: {
      userLoggedIn: _vm.isUserLoggedIn
    }
  }, [_c('div', {
    staticClass: "full-bg-img p-t-6"
  }, [_c('Carousel', {
    staticClass: "carousel",
    attrs: {
      "images": _vm.images,
      "interval": 5000
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid mainContent"
  }, [_c('img', {
    staticClass: "logo m-t-3 m-b-3",
    attrs: {
      "src": "/static/img/logo-booknatura-green.svg",
      "width": "200px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "white-text text-xs-center wow fadeInUp"
  }, [_c('h2', [_vm._v(_vm._s(_vm.t('Discover the natural wonders of Portugal')))]), _vm._v(" "), _c('h5', {
    staticClass: "tagline"
  }, [_vm._v(_vm._s(_vm.t('Book your tours, adventure activities or nature watching')))]), _vm._v(" "), _c('search', {
    staticClass: "m-t-4 m-b-4 z-depth-4"
  })], 1)])], 1)]), _vm._v(" "), _c('Newsletter'), _vm._v(" "), _c('Recomendations'), _vm._v(" "), _c('HowDoesItWork'), _vm._v(" "), _c('SearchLinks', {
    staticClass: "m-b-3"
  }), _vm._v(" "), _c('Testimonials'), _vm._v(" "), _c('Mission')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-ba2dfb56", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ba2dfb56"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Home.vue
// module id = 801
// module chunks = 3